module.exports = {"title":"A new price has been created","ok":"Got it!","description":"Please make sure you go on each date to select the default value of that price.","description2":"Click on Customize Pricing button to change those values."}


//////////////////
// WEBPACK FOOTER
// ./src/components/CreateEvent/MTIModal/locales/fr.json
// module id = 1682
// module chunks = 0